import { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'
import { ContentSource } from 'constants/tracking/content-sources'

type ConfirmWalletEventArgs = {
  source: ContentSource
  prefilled_billing_address?: boolean | null
}

type ConfirmWalletEventExtra = {
  source: string
  prefilled_billing_address?: boolean | null
}

export const confirmWalletEvent = (args: ConfirmWalletEventArgs): TrackingEvent => {
  const extra: ConfirmWalletEventExtra = {
    source: args.source,
  }

  return {
    event: 'user.confirm_wallet',
    extra,
  }
}
